import { ReactNode, useCallback, useState } from 'react';

import { Tabbar, type TabbarProps } from '@widgets/tabbar';

import { BottomSheetConfig, TabbarContext } from './useTabbar';

interface TabbarProviderProps extends TabbarProps {
  children: React.ReactNode;
}

export const TabbarProvider = ({ children }: TabbarProviderProps) => {
  const [showNavigation, setShowNavigation] = useState<boolean>(true);
  const [showBottomSheet, setShowBottomSheet] = useState<boolean>();
  const [bottomSheet, setBottomSheetState] = useState<React.ReactNode>();
  const [, setBottomSheetConfig] = useState<BottomSheetConfig>({});

  const setBottomSheet = useCallback(
    (node: ReactNode, config?: BottomSheetConfig) => {
      setBottomSheetState(node);
      config && setBottomSheetConfig(config);
    },
    [],
  );

  return (
    <TabbarContext.Provider
      value={{
        showNavigation: showNavigation,
        showBottomSheet: showBottomSheet,
        bottomSheet: bottomSheet,
        setShowNavigation: setShowNavigation,
        setShowBottomSheet: setShowBottomSheet,
        setBottomSheet: setBottomSheet,
      }}
    >
      {children}
      <Tabbar
        showNavigation={showNavigation}
        showBottomSheet={showBottomSheet}
        bottomSheet={bottomSheet}
      />
    </TabbarContext.Provider>
  );
};
